export const addFilterTransformation = (prevFilters, filterId, filterValue) => {
  const newFilters = { ...(prevFilters || {}) };

  if (typeof newFilters[filterId] === "undefined") {
    newFilters[filterId] = [filterValue];
  } else if (!newFilters[filterId].includes(filterValue)) {
    newFilters[filterId].push(filterValue);
  }

  return newFilters;
};

export const setFilterTransformation = (prevFilters, filterId, filterValues) => {
  if (!filterValues || !filterValues.length) {
    throw new Error(
      "Param filterValues must be an array with at least one value."
    );
  }

  const newFilters = { ...(prevFilters || {}) };
  newFilters[filterId] = filterValues;

  return newFilters;
};

export const removeFilterTransformation = (prevFilters, filterId, filterValue) => {
  const removeAllValues =
    typeof filterValue === "undefined" || filterValue === null;

  if (!prevFilters || typeof prevFilters[filterId] === "undefined") {
    return prevFilters;
  }

  const newFilters = { ...(prevFilters || {}) };

  if (removeAllValues) {
    delete newFilters[filterId];
  } else {
    newFilters[filterId] = newFilters[filterId].filter(
      (value) => value !== filterValue
    );

    if (newFilters[filterId].length === 0) {
      delete newFilters[filterId];
    }
  }

  return newFilters;
};

export const resetFilterTransformation = (prevFilters, filterId) => {
  const newFilters = { ...(prevFilters || {}) };
  delete newFilters[filterId];
  return newFilters;
};